import 'jquery-ajax-unobtrusive';
import '../../../scss/sites/aircomponents/aircomponents-style.scss';
import Header from '@png/npm-header';
import SelectDropdown from '@png/npm-select-dropdown';
import SvgIcon from '@png/npm-svg-icon';
import AddressLookup from '../../modules/address-lookup';
import ClearCache from '../../modules/clear-cache';
import CookieConsent from '../../modules/cookie-consent';
import FilterTags from '../../modules/filter-tags';
// import FloatingLabels from '../../modules/floating-labels';
import Incrementer from '../../modules/incrementer';
import LightGallery from '../../modules/light-gallery';
import Pagination from '../../modules/pagination';
import Sticky from '../../modules/sticky';
import Video from '../../modules/video';
import Toast from '../../modules/toast';
import Popup from '../../modules/popup';
import SmoothScroll from '../../modules/smooth-scroll';
import EqualHeight from '../../modules/equal-height';
import PriceUpdate from '../../modules/price-update';
import OrderHistory from '../../modules/order-history';
import MacroUseButtonUrl from '../../modules/macro-use-button-url';
import Impersonate from '../../modules/impersonate';
import ProductFavorite from '../../modules/product-favorite';
// import ReadMoreLess from '../../modules/read-more-less';
import CatalogSearch from '../../modules/catalog-search';
import RoundNearestStep from '../../modules/round-nearest-step';
import RealTimePrice from '../../modules/real-time-price';
import RealTimeStock from '../../modules/real-time-stock';
import NativeApp from '../../modules/native-app';
import NativeAppPDF from '../../modules/native-app-pdf';
import Recaptcha from '../../modules/recaptcha';
import OrderHistoryDropdown from '../../modules/catalog/order-history-dropdown';
import FunnelActivityPusher from '../../modules/activity-pusher';
import SaveShoppingCart from '../../modules/catalog/save-shopping-cart';
import RealTimePriceStaffels from '../../modules/catalog/real-time-price-staffels';
import ProductLayout from '../../modules/catalog/ProductLayout';
import OverviewPageFilters from '../../modules/overview-page-filters';
import DataLayerController from '../../modules/DataLayerController';
import AddressesHandler from '../../modules/AddressesHandler';
import BlockUseButtonUrl from '../../modules/block-use-button-url';
import DownloadPriceList from '../../modules/download-pricelist';
import PasswordToggle from '../../modules/PasswordToggle';
import KvkCheck from '../../modules/kvk-check';
// import CrossSellProducts from '../../modules/catalog/crosssell-products';
// import QuickOrderFavorite from '../../modules/quickorder-favorite';

document.addEventListener('DOMContentLoaded', () => {
  const modules = [
    new DataLayerController(),
    // new QuickOrderFavorite(),
    new Recaptcha(),
    new AddressesHandler(),
    new CatalogSearch(),
    new RoundNearestStep(),
    new RealTimePrice(),
    new RealTimeStock(),
    new ProductFavorite(),
    new SvgIcon(),
    new Header({
      desktopMenuBreakpoint: 992,
      openUrlOnToggle: false
    }),
    new Sticky({
      velocity: 50
    }),
    // new FloatingLabels(),
    new CookieConsent(),
    new Incrementer(),
    new FilterTags(),
    new Video(),
    new LightGallery(),
    new MacroUseButtonUrl({
      rowClickable: ['row-10b', 'row-10a']
    }),
    new Popup(),
    // new ReadMoreLess({
    //   dots: true
    // }),
    new SelectDropdown(),
    new OrderHistory(),
    new Pagination(),
    new SmoothScroll(),
    new EqualHeight(),
    new PriceUpdate(),
    new AddressLookup(),
    new Toast({
      duration: 3000,
      close: true
    }),
    new ClearCache(),
    new Impersonate(),
    new NativeApp(),
    new NativeAppPDF(),
    new FunnelActivityPusher(),
    new OrderHistoryDropdown(),
    new SaveShoppingCart(),
    new RealTimePriceStaffels(),
    new ProductLayout(),
    new OverviewPageFilters(),
    new BlockUseButtonUrl(),
    new DownloadPriceList(),
    new PasswordToggle(),
    new KvkCheck()
    // new RegisterAccount()
    // new CrossSellProducts()
  ];

  modules.forEach(module => {
    if (module && module.init) {
      module.init();
    }
  });

  window.addEventListener('triggerRealtimePrice', () => {
    new RealTimePrice().init();
  });
});
